export default __webpack_public_path__ + "static/media/x.4426bd66.png";